// Product Video Pop-up
function videoPop() {
  document.getElementById("product-video-popup").style.display = "grid";
}

function shippingVideoPop() {
  document.getElementById("product-shipping-video-popup").style.display = "grid";
}

function closeVideo() {
  document.getElementById("product-video-popup").style.display = "none";
  document.getElementById("product-shipping-video-popup").style.display = "none";
}
// Product bf Coupon
function bfPop() {
  document.getElementById("bf-popup").style.display = "grid";
}

function closeBf() {
  document.getElementById("bf-popup").style.display = "none";
}


// Cyber Monday Pop-up
function cyberPop() {
  document.getElementById("cyber-popup").style.display = "grid";
}

function closeCyber() {
  document.getElementById("cyber-popup").style.display = "none";
}

// let text06 = document.getElementById('icon-coupon-cyber').innerText;
//   const copyCodeC = async () => {
//     try {
//       await navigator.clipboard.writeText(text06);
//       console.log('Content copied to clipboard');
//     } catch (err) {
//       console.error('Failed to copy: ', err);
//     }
//   }
// Showroom pick-up promo modal. Only rendered on product templates, so this
// runs site-wide but must tolerate the element being absent.
function showroompickupPop() {
  var el = document.getElementById("showroom-promo-pickup-popup");
  if (el) el.style.display = "grid";
}

function closeshowroompickupPop() {
  var el = document.getElementById("showroom-promo-pickup-popup");
  if (el) el.style.display = "none";
}

          document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.getElementById('toggle-description');
  var desc = document.getElementById('collection-description');

  if (toggle && desc) {
    toggle.addEventListener('click', function () {
      desc.classList.toggle('expanded');
      var isExpanded = desc.classList.contains('expanded');
      toggle.textContent = isExpanded ? toggle.dataset.seeLess : toggle.dataset.seeMore;
      toggle.setAttribute('aria-expanded', isExpanded.toString());
    });
  }
});


          
  document.addEventListener("DOMContentLoaded", function () {
    document.body.classList.add("announcement-offset");
  });

(function () {
  var scriptPromises = {};
  var zendeskConfigured = false;

  function loadScript(id, src) {
    if (scriptPromises[id]) return scriptPromises[id];

    scriptPromises[id] = new Promise(function (resolve) {
      var existingScript = document.getElementById(id);
      if (existingScript) {
        if (existingScript.dataset.loaded === 'true') {
          resolve(true);
          return;
        }
        existingScript.addEventListener('load', resolve, { once: true });
        existingScript.addEventListener('error', function () { resolve(false); }, { once: true });
        return;
      }

      var script = document.createElement('script');
      script.id = id;
      script.src = src;
      script.async = true;
      script.addEventListener('load', function () {
        script.dataset.loaded = 'true';
        resolve(true);
      }, { once: true });
      script.addEventListener('error', function () { resolve(false); }, { once: true });
      document.head.appendChild(script);
    });

    return scriptPromises[id];
  }

  // html.tmg-chat-open hides the floating contact bar while the chat window is up.
  function configureZendesk() {
    if (zendeskConfigured || typeof window.zE !== 'function') return;
    zendeskConfigured = true;
    var html = document.documentElement;
    window.zE('webWidget', 'hide');
    window.zE('webWidget:on', 'open', function () {
      html.classList.add('tmg-chat-open');
    });
    window.zE('webWidget:on', 'close', function () {
      html.classList.remove('tmg-chat-open');
      window.zE('webWidget', 'hide');
    });
  }

  function afterWindowLoad() {
    if (document.readyState === 'complete') return Promise.resolve();
    return new Promise(function (resolve) {
      window.addEventListener('load', resolve, { once: true });
    });
  }

  // Resolves true once window.zE exists, false if the snippet fails or zE never shows up.
  // The Zendesk Shopify app injects the same snippet (#ze-snippet) on window load, so
  // wait for load and only add it here when the app didn't; two copies boot two widgets.
  // Waits on zE itself rather than a load event, which may already be gone.
  var zendeskReady;
  window.tmgLoadZendesk = function () {
    if (zendeskReady) return zendeskReady;

    zendeskReady = afterWindowLoad().then(function () {
      var failed = false;
      if (!document.querySelector('#ze-snippet, script[src*="zendesk-embeddable"]')) {
        loadScript(
          'ze-snippet',
          'https://static.zdassets.com/ekr/snippet.js?key=58a78508-fbd3-41d3-a85e-bf5c23d41d74'
        ).then(function (ok) {
          if (ok === false) failed = true;
        });
      }

      return new Promise(function (resolve) {
        var tries = 0;
        (function check() {
          if (typeof window.zE === 'function') return resolve(true);
          if (failed || ++tries > 100) return resolve(false);
          window.setTimeout(check, 100);
        })();
      });
    }).then(function (ok) {
      configureZendesk();
      return ok;
    });

    return zendeskReady;
  };

  window.openZendeskWidget = function (event) {
    if (event) event.preventDefault();
    window.tmgLoadZendesk().then(function (ok) {
      if (ok) {
        window.zE('webWidget', 'show');
        window.zE('webWidget', 'open');
      } else {
        // Widget blocked or failed to load (e.g. an ad blocker): use the contact page instead.
        var rootUrl = (window.Theme && window.Theme.routes && window.Theme.routes.root_url) || '/';
        window.location.href = rootUrl.replace(/\/$/, '') + '/pages/contact';
      }
    });
  };

  function setupZendesk() {
    var loadZendesk = function () {
      window.tmgLoadZendesk();
    };
    var triggers = document.querySelectorAll(
      '.quick-contact-badge-email, [data-zendesk], [onclick*="openZendeskWidget"]'
    );

    triggers.forEach(function (trigger) {
      trigger.addEventListener('mouseenter', loadZendesk, { once: true });
      trigger.addEventListener('focus', loadZendesk, { once: true });
      trigger.addEventListener('touchstart', loadZendesk, { once: true, passive: true });
      trigger.addEventListener('pointerdown', loadZendesk, { once: true, passive: true });
    });

    // #tmg-zendesk-launcher is the old standalone launcher, kept in snippets but not rendered.
    document.querySelectorAll('#tmg-fab-msg, #tmg-zendesk-launcher').forEach(function (launcher) {
      launcher.addEventListener('click', window.openZendeskWidget);
    });

    var loadAfterPageSettles = function () {
      // Already loading via the Zendesk app (its script tag is added on load, before
      // this runs): configure now so the app's own launcher is hidden instead of
      // sitting over the floating contact bar.
      var appLoading = document.querySelector('#ze-snippet, script[src*="zendesk-embeddable"]');
      window.setTimeout(loadZendesk, appLoading ? 0 : 10000);
    };

    if (document.readyState === 'complete') {
      loadAfterPageSettles();
    } else {
      window.addEventListener('load', loadAfterPageSettles, { once: true });
    }
  }

  // ---- Stamped (product review badges + reviews widget) ----
  // Renders visible rating badges, so it must still load automatically — but its
  // ~216KB bundle + init no longer run during the busy initial-load window.
  window.tmgLoadStamped = function () {
    return loadScript(
      'stamped-widget',
      'https://cdn1.stamped.io/files/widget.min.js'
    ).then(function (ok) {
      if (ok && window.StampedFn && typeof window.StampedFn.init === 'function') {
        window.StampedFn.init({
          apiKey: 'pubkey-R3kK440GU94Lx6PRYbc8Ra2YODKMg9',
          storeUrl: '195453'
        });
      }
      return ok;
    });
  };

  // ---- CallRail (dynamic phone-number swap; analytics only) ----
  window.tmgLoadCallrail = function () {
    return loadScript(
      'callrail-swap',
      'https://cdn.callrail.com/companies/842230100/d8207381355ea32ccbc4/12/swap.js'
    );
  };

  // ---- Microsoft Clarity (session analytics) ----
  // Loads as soon as the page has finished loading — no idle gap, interaction or
  // timeout gate, so sessions are captured for every visitor who reaches load.
  window.tmgLoadClarity = function () {
    if (window.clarity) return;
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', 'vew6qysukg');
  };

  function setupClarity() {
    if (document.readyState === 'complete') {
      window.tmgLoadClarity();
    } else {
      window.addEventListener('load', window.tmgLoadClarity, { once: true });
    }
  }

  // Schedule non-visual/idle work in a real gap between tasks, with a timeout
  // fallback for browsers without requestIdleCallback (Safari).
  function whenIdle(fn, timeout) {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(fn, { timeout: timeout || 4000 });
    } else {
      window.setTimeout(fn, 2000);
    }
  }

  // Vendors that must appear automatically but not compete with the critical
  // load: kick them off once the page has fully loaded, during the first idle gap.
  function setupIdleVendors() {
    var utmSource = new URLSearchParams(window.location.search).get('utm_source');
    var loadIdleVendors = function () {
      whenIdle(function () { window.tmgLoadStamped(); });
      if (utmSource && utmSource.trim()) {
        whenIdle(function () { window.tmgLoadCallrail(); });
      }
    };

    if (document.readyState === 'complete') {
      loadIdleVendors();
    } else {
      window.addEventListener('load', loadIdleVendors, { once: true });
    }
  }

  function setupDeferredVendors() {
    setupZendesk();
    setupIdleVendors();
    setupClarity();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupDeferredVendors, { once: true });
  } else {
    setupDeferredVendors();
  }
})();



  document.addEventListener("DOMContentLoaded", function () {
    const container = document.querySelector(".announcement-slider-container");
    const slider = document.getElementById("announcement-slider");

    if (container) {
      container.classList.add("is-visible");
    }

    // Guard: pages without an announcement slider (e.g. product pages) have no
    // #announcement-slider. Without this, `slider.children` threw an uncaught
    // TypeError that aborted the rest of this DOMContentLoaded handler.
    if (!slider) return;

    let slides = Array.from(slider.children).filter(slide => {
      return window.getComputedStyle(slide).display !== "none";
    });

    let currentIndex = 0;
    let isTransitioning = false;

    // Clone the first slide and append to end
    const firstClone = slides[0].cloneNode(true);
    firstClone.classList.add("clone");
    slider.appendChild(firstClone);
    slides.push(firstClone); // update slides list

    const totalSlides = slides.length;

    function updateSlider(index, animate = true) {
      slider.style.transition = animate ? 'transform 0.5s ease' : 'none';
      slider.style.transform = `translateX(-${index * 100}%)`;
    }

    function nextSlide() {
      if (isTransitioning) return;
      isTransitioning = true;

      currentIndex++;
      updateSlider(currentIndex);
    }

    function prevSlide() {
      if (isTransitioning) return;
      if (currentIndex === 0) {
        currentIndex = totalSlides - 2;
        updateSlider(currentIndex, false);
      } else {
        currentIndex--;
        updateSlider(currentIndex);
      }
      isTransitioning = true;
    }

    slider.addEventListener("transitionend", () => {
      // If we're on the clone, jump to real first slide
      if (slides[currentIndex]?.classList.contains("clone")) {
        slider.style.transition = "none";
        currentIndex = 0;
        updateSlider(currentIndex, false);
      }
      isTransitioning = false;
    });

    const nextBtn = document.querySelector(".announcement-nav.next");
    const prevBtn = document.querySelector(".announcement-nav.prev");

    if (nextBtn) nextBtn.addEventListener("click", nextSlide);
    if (prevBtn) prevBtn.addEventListener("click", prevSlide);

    setInterval(() => {
      nextSlide();
    }, 8000); // autoplay every 8s
  });
